export const ADD_OEM_REQUEST = "ADD_OEM_REQUEST";
export const ADD_OEM_RESULT = "ADD_OEM_RESULT";
export const ADD_OEM_OPEN_MODAL = "ADD_OEM_OPEN_MODAL";
export const ADD_OEM_CLOSE_MODAL = "ADD_OEM_CLOSE_MODAL";
export const ADD_OEM_GET_INTEGRATIONS_REQUEST = "ADD_OEM_GET_INTEGRATIONS_REQUEST";
export const ADD_OEM_GET_INTEGRATIONS_RESULT = "ADD_OEM_GET_INTEGRATIONS_RESULT";

export const ADD_OEM_SET_INTEGRATIONS = "ADD_OEM_SET_INTEGRATIONS";


